import React from "react";
import { useDispatch } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import ConfirmationPopup from "components/ConfirmationPopup";
import { setRiskCandidateForDeletion } from "store/actions/vetHorseDetailsPage";
import { useRacehorse360Api } from "hooks/api";
import { LIST_HORSE_RISK_TOTAL_RESULTS_QUERY_KEY } from "../RiskList/RiskList";

import useStyles from "./styles";

interface IProps {
  horse: racehorse360.IHorse;
  risk?: racehorse360.IHorseRisk;
}

const RemoveCustomRiskPopup = (props: IProps) => {
  const { horse, risk } = props;
  const riskFactor = risk.riskFactor;

  const classes = useStyles();
  const disaptch = useDispatch();
  const queryClient = useQueryClient();

  const { useDeleteHorseRisk } = useRacehorse360Api();

  const { mutateAsync: deleteHorseRisk } = useDeleteHorseRisk();

  const handleCloseCustomRiskPopup = () => {
    disaptch(setRiskCandidateForDeletion(null));
  };

  const handleRemoveCustomRisk = () => {
    return deleteHorseRisk({ id: risk.id }).then(() => {
      handleCloseCustomRiskPopup();
      queryClient.invalidateQueries({
        queryKey: [LIST_HORSE_RISK_TOTAL_RESULTS_QUERY_KEY]
      });
    });
  };

  const riskFactorDescription =
    riskFactor?.detailedDescription ||
    riskFactor?.description ||
    riskFactor?.shortDescription;

  return (
    <ConfirmationPopup
      className={classes.customRiskPopup}
      open={true}
      title={"DELETE RISK FACTOR"}
      onConfirm={handleRemoveCustomRisk}
      onCancel={handleCloseCustomRiskPopup}
      onClose={handleCloseCustomRiskPopup}
      confirmButtonText={"Delete"}
      cancelButtonText={"Back"}
      notification={`${riskFactorDescription} has been removed from ${horse.name}`}
      positive={false}
    >
      <span>{riskFactorDescription}</span>
    </ConfirmationPopup>
  );
};

export default React.memo(RemoveCustomRiskPopup);
